import React, { useContext }from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../../Store';

function TermsAndConditionsLink({ label, linkId = 'n/a' }) {
	const state = useContext(AppContext)[0];

	return (
		<a
			href={state.termsAndConditionsUrl}
			target="_blank"
			id={linkId}
			rel="noreferrer"
		>
			{label}
		</a>
	);
}

export default TermsAndConditionsLink;

TermsAndConditionsLink.propTypes = {
	label: PropTypes.string.isRequired,
	linkId: PropTypes.string,
};

